import { use, useEffect, useState } from 'react';
import { FormContext } from '../components/Form/FormContext';

export function useFormFieldError(fieldName: string) {
  const { error: formError } = use(FormContext);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (formError) {
      setShowError(true);
    }
  }, [formError]);

  let fieldError: string | null = null;
  if (formError) {
    const regex = new RegExp(
      `\\["${fieldName}"\\][^:]*: (.+?)(?=(\\n|$))`,
      'i',
    );
    const matches = formError.match(regex);
    fieldError = matches?.[1]?.trim() || 'This field is required';
  }

  return { fieldError, showError, formError };
}
